    const ValidationUtils = {
  validateForm: (formData, variableSamples, file) => {
    const { name, header, bodyText, footer, buttons } = formData;
    
    // Validate template name
    if (!name.match(/^[a-z0-9_]+$/)) {
      return "Template name must be lowercase, numbers, or underscores only";
    }
    
    // Validate body content length
    if (bodyText.length > 1024) {
      return "Body content must be 1024 characters or less";
    }
    
    // Validate header text length
    if (header.type === "TEXT" && header.text.length > 60) {
      return "Header text must be 60 characters or less";
    }
    
    // Validate media header
    if (["IMAGE", "VIDEO", "DOCUMENT"].includes(header.type) && !file) {
      return "Media file is required for media headers";
    }
    
    // Validate footer length
    if (footer.length > 60) {
      return "Footer text must be 60 characters or less";
    }
    
    // Validate buttons count
    if (buttons.length > 10) {
      return "Maximum 10 buttons allowed";
    }
    
    // Validate buttons
    for (const button of buttons) {
      if (!button.text) {
        return "Button text is required";
      }
      
      if (button.type === "URL" && !/^https?:\/\/[^\s$.?#].[^\s]*$/.test(button.url)) {
        return "Invalid URL in button";
      }
      
      if (button.type === "PHONE_NUMBER" && !/^\+?\d{10,15}$/.test(button.phone_number)) {
        return "Invalid phone number in button";
      }
      
      if (button.type === "COPY_CODE" && !button.coupon_code) {
        return "Coupon code is required for copy code buttons";
      }
    }
    
    // Validate variable samples
    const variablesInBody = bodyText.match(/\{\{\d+\}\}/g) || [];
    if (variablesInBody.length > 0) {
      for (let i = 0; i < variableSamples.length; i++) {
        if (!variableSamples[i] || variableSamples[i].trim() === "") {
          return `Sample value for variable {{${i + 1}}} is required`;
        }
      }
    }
    
    return null; // No errors
  }
};

export default ValidationUtils;